import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhotosynIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 39,
	viewBox: "0 0 44 39",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3791_13242)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M27.66 18.76H26.6C26.6 20.93 25.72 22.88 24.3 24.3C22.88 25.72 20.92 26.59 18.76 26.6C16.59 26.6 14.64 25.72 13.22 24.3C11.8 22.88 10.93 20.92 10.92 18.76C10.92 16.59 11.8 14.64 13.22 13.22C14.64 11.8 16.6 10.93 18.76 10.92C20.93 10.92 22.88 11.8 24.3 13.22C25.72 14.64 26.59 16.6 26.6 18.76H28.72C28.72 13.25 24.26 8.79004 18.75 8.79004C13.24 8.79004 8.78003 13.25 8.78003 18.76C8.78003 24.27 13.24 28.73 18.75 28.73C24.26 28.73 28.72 24.27 28.72 18.76H27.66Z",
					fill: "#2C3F81"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.7 1.06V5.55C17.7 6.13 18.18 6.61 18.76 6.61C19.34 6.61 19.82 6.13 19.82 5.55V1.06C19.82 0.48 19.34 0 18.76 0C18.18 0 17.7 0.47 17.7 1.06Z",
					fill: "#2C3F81"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.7 31.9699V36.4599C17.7 37.0399 18.18 37.5199 18.76 37.5199C19.34 37.5199 19.82 37.0399 19.82 36.4599V31.9699C19.82 31.3899 19.34 30.9099 18.76 30.9099C18.18 30.9099 17.7 31.3899 17.7 31.9699Z",
					fill: "#2C3F81"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.53 5.49998L27.36 8.66998C26.95 9.07998 26.95 9.75998 27.36 10.17C27.77 10.58 28.45 10.58 28.86 10.17L32.03 6.99998C32.44 6.58998 32.44 5.90998 32.03 5.49998C31.62 5.08998 30.94 5.07998 30.53 5.49998Z",
					fill: "#2C3F81"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.66988 27.35L5.49988 30.52C5.08988 30.93 5.08988 31.61 5.49988 32.02C5.90988 32.43 6.58988 32.43 6.99988 32.02L10.1699 28.85C10.5799 28.44 10.5799 27.76 10.1699 27.35C9.75988 26.94 9.07988 26.94 8.66988 27.35Z",
					fill: "#2C3F81"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.4599 17.7H31.9699C31.3899 17.7 30.9099 18.18 30.9099 18.76C30.9099 19.34 31.3899 19.82 31.9699 19.82H36.4599C37.0399 19.82 37.5199 19.34 37.5199 18.76C37.5199 18.18 37.0499 17.7 36.4599 17.7Z",
					fill: "#2C3F81"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.55 17.7H1.06C0.48 17.7 0 18.18 0 18.76C0 19.34 0.48 19.82 1.06 19.82H5.55C6.13 19.82 6.61 19.34 6.61 18.76C6.61 18.18 6.14 17.7 5.55 17.7Z",
					fill: "#2C3F81"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.03 30.52L28.86 27.35C28.45 26.94 27.77 26.94 27.36 27.35C26.95 27.76 26.95 28.44 27.36 28.85L30.53 32.02C30.94 32.43 31.62 32.43 32.03 32.02C32.44 31.61 32.44 30.93 32.03 30.52Z",
					fill: "#2C3F81"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1699 8.66988L6.99988 5.49988C6.58988 5.08988 5.90988 5.08988 5.49988 5.49988C5.08988 5.90988 5.08988 6.58988 5.49988 6.99988L8.66988 10.1699C9.07988 10.5799 9.75988 10.5799 10.1699 10.1699C10.5799 9.75988 10.5899 9.07988 10.1699 8.66988Z",
					fill: "#2C3F81"
				})
			]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3791_13242",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 24,
			y: 19,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 24,
				y: 19,
				width: 19.1668,
				height: 19.8108,
				fill: "#1F3171"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_3791_13242)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M34.5102 24.6678L34.1509 25.0154L34.5102 24.6678C34.26 24.4092 33.9394 24.2781 33.5819 24.2781C33.2244 24.2781 32.9037 24.4092 32.6535 24.6678C32.4042 24.9255 32.2832 25.2489 32.2832 25.6036V28.9054C32.2832 29.2601 32.4042 29.5835 32.6535 29.8412C32.9037 30.0998 33.2244 30.2308 33.5819 30.2308C33.9394 30.2308 34.26 30.0998 34.5102 29.8412C34.7595 29.5835 34.8805 29.2601 34.8805 28.9054V25.6036C34.8805 25.2489 34.7595 24.9255 34.5102 24.6678ZM34.5102 31.2714L34.1509 31.619L34.5102 31.2714C34.26 31.0128 33.9394 30.8817 33.5819 30.8817C33.2244 30.8817 32.9037 31.0128 32.6535 31.2714L33.0128 31.619L32.6535 31.2714C32.4042 31.5291 32.2832 31.8525 32.2832 32.2072C32.2832 32.5619 32.4042 32.8853 32.6535 33.143L33.0128 32.7953L32.6535 33.143C32.9037 33.4016 33.2244 33.5326 33.5819 33.5326C33.9394 33.5326 34.26 33.4016 34.5102 33.143L34.1509 32.7953L34.5102 33.143C34.7595 32.8853 34.8805 32.5619 34.8805 32.2072C34.8805 31.8525 34.7595 31.5291 34.5102 31.2714ZM33.5819 36.6599C32.5445 36.6599 31.576 36.4569 30.6709 36.0532C29.7559 35.6451 28.964 35.0934 28.291 34.3978C27.6179 33.7021 27.0825 32.8818 26.686 31.932C26.2935 30.9917 26.0957 29.9844 26.0957 28.9054C26.0957 27.8263 26.2935 26.819 26.686 25.8787C27.0825 24.929 27.6179 24.1087 28.291 23.413C28.964 22.7174 29.7559 22.1657 30.6709 21.7576C31.576 21.3539 32.5445 21.1509 33.5819 21.1509C34.6192 21.1509 35.5877 21.3539 36.4928 21.7576C37.4078 22.1657 38.1997 22.7174 38.8727 23.413C39.5458 24.1087 40.0812 24.929 40.4777 25.8787C40.8702 26.819 41.068 27.8263 41.068 28.9054C41.068 29.9844 40.8702 30.9917 40.4777 31.932C40.0812 32.8818 39.5458 33.7021 38.8727 34.3978C38.1997 35.0934 37.4078 35.6451 36.4928 36.0532C35.5877 36.4569 34.6192 36.6599 33.5819 36.6599Z",
				fill: "#1F3171",
				stroke: "#1F3171"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3791_13242",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 37.52,
				height: 37.52,
				fill: "white"
			})
		}) })
	]
});
export default SvgPhotosynIcon;
